(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-loadout-video]').forEach((container) => {
      if (container.dataset.ready) return;
      const video = container.querySelector('video');
      if (!video) return;
      container.dataset.ready = 'true';
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      const shouldPlay = () => visible && !reducedMotion.matches;
      const sync = () => {
        if (shouldPlay()) video.play().catch(() => {});
        else video.pause();
      };
      video.addEventListener('play', () => { if (!shouldPlay()) video.pause(); });
      new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        sync();
      }, { threshold: 0.2 }).observe(container);
      reducedMotion.addEventListener('change', sync);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
